import { forwardRef, memo, useCallback, useState } from "react";

import { ReactComponent as EyeCloseIcon } from "assets/icons/eye-close.svg";
import { ReactComponent as EyeIcon } from "assets/icons/eye.svg";
import TextField, { TextFieldProps } from "./TextField";

const PasswordTextField = memo(
  forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
      setShowPassword((b) => !b);
    };

    const renderShowPassword = useCallback(
      () => (
        <button
          type="button"
          className="inline-flex"
          onClick={toggleShowPassword}
        >
          <span className="size-6 inline-flex justify-center items-center">
            {showPassword ? (
              <EyeIcon className="size-[1.313rem]" />
            ) : (
              <EyeCloseIcon className="size-[1.313rem]" />
            )}
          </span>
        </button>
      ),
      [showPassword],
    );
    return (
      <TextField
        ref={ref}
        {...props}
        type={showPassword ? "text" : "password"}
        suffixComponent={renderShowPassword}
      />
    );
  }),
);

export default PasswordTextField;
